import { render, staticRenderFns } from "./WarringList.vue?vue&type=template&id=4ca665f0&scoped=true"
import script from "./WarringList.vue?vue&type=script&lang=js"
export * from "./WarringList.vue?vue&type=script&lang=js"
import style0 from "./WarringList.vue?vue&type=style&index=0&id=4ca665f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca665f0",
  null
  
)

export default component.exports